import React from 'react';
import { useNavigate } from 'react-router-dom';
import notFound from '../../../assets/images/not-found.png';
import { ButtonPestLine } from '../../utils/Button';
import { mkRelativeUrl } from '../../utils/URL';
import cn from '../../utils/cn';

function NotFound({
    title,
    btnTitle = 'Back to Home',
    evButtonClick,
    path = mkRelativeUrl('/dashboard'),
    className = ''
}) {
    const navigate = useNavigate();
    const handelButtonClick = () => {
        if (evButtonClick) {
            evButtonClick();
        } else {
            navigate(path);
        }
    };
    /**
     */
    return (
        <div
            className={cn(
                'bg-white w-full h-screen max-w-xl mx-auto overflow-hidden flex flex-col justify-center items-center rounded-[20px]',
                className
            )}
        >
            <img src={notFound} alt="" className="w-full max-w-2xl mb-5 select-none" />
            <h2 className="text-primary text-lg font-normal mb-4">{title || '404 | Not Found'}</h2>

            {btnTitle && (
                <ButtonPestLine
                    onClick={handelButtonClick}
                    title={btnTitle || 'Back'}
                    className="h-11 w-36 text-lg"
                />
            )}
        </div>
    );
}

export default NotFound;
